<template>
  <v-menu
    bottom
    offset-y
    :close-on-content-click="closeOnContentClick"
    :data-testid="testId"
    :left="left"
    :max-height="maxHeight"
    :right="right"
  >
    <template v-slot:activator="{ on, value }">
      <slot name="activator" :on="on" :value="value"></slot>
    </template>

    <div class="white" style="max-height:300px">
      <v-list nav dense class="px-1 py-1 rever-menu">
        <template v-for="(option, index) in options">
          <v-divider v-if="option.divider" :key="`divider_${index}`" />

          <v-list-group
            v-else-if="option.subOptions"
            :key="option.id + 'group'"
          >
            <template v-slot:activator>
              <v-list-item :data-testid="option.testId">
                <v-list-item-icon v-if="option.icon" class="mr-1">
                  <v-icon> {{ option.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title> {{ option.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-list-item
              class="px-7"
              v-for="subOption in option.subOptions"
              :key="`${subOption.id}_${index}`"
              :data-testid="subOption.testId"
              @click="subOption.action"
            >
              <v-list-item-icon v-if="subOption.icon" class="mr-1">
                <v-icon> {{ subOption.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> {{ subOption.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item
            v-else-if="!option.subOptions"
            color="blue"
            :key="`${option.id}_${index}`"
            :input-value="selectedOption === option.id"
            :data-testid="option.testId"
            :data-tourid="option.tourId"
            @click="handleItemClick(option)"
          >
            <v-list-item-icon v-if="option.icon" class="mr-1">
              <v-icon> {{ option.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title> {{ option.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </div>
  </v-menu>
</template>

<script>
export default {
  name: 'Menu',

  props: {
    options: {
      type: Array,
      required: true,
    },

    testId: {
      type: String,
      required: false,
    },

    tourId: {
      type: String,
      required: false,
    },

    closeOnContentClick: {
      type: Boolean,
      default: true,
    },

    selectedOption: {
      type: String,
      required: false,
      default: null,
    },

    right: {
      type: Boolean,
      default: false,
    },

    left: {
      type: Boolean,
      default: false,
    },

    maxHeight: {
      type: [Number, String],
      default: 'auto',
    },
  },

  methods: {
    handleItemClick(option) {
      this.$emit('click', option)
      if (option.action) option.action()
    },
  },
}
</script>
<style lang="scss">
.rever-menu {
  .v-item--active {
    background-color: $color-blue-lighten2 !important;
    color: $color-blue !important;
  }
  .v-list .v-list-item--active .v-icon {
    color: $color-blue !important;
  }

  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
    color: $color-blue-grey-darken2 !important;
  }
  .theme--light.v-icon,
  .theme--dark.v-icon {
    color: inherit !important;
  }
}
</style>
